module.exports = __webpack_public_path__ + "media/bootstrap-icons/layout-split-bab616e1.svg";